import React from 'react'
import { Ratio } from 'react-bootstrap'
import { useDispatch,useSelector } from 'react-redux'
import { setEraserS } from '../../store/modules/eraser'
import styles from './index.module.css';
import { darkenColor } from '../../utils/publicfunction';

export default function Btneraser() {
  const {e}=useSelector((state)=>state.eraser);
  const {p}=useSelector((state)=>state.pencil);//pencil按钮状态，false
  const {c}=useSelector((state)=>state.palette);//调色板的状态，数字
  const dispatch=useDispatch();

  const er= e>0 ? styles.eraserdown : "";

  // 功能键背景色
  const {bm}=useSelector((state)=>state.colorplate);
  const darkenedColor = darkenColor(bm, 0.3);
  const buttonStyle = {
    backgroundColor: e>0 ? darkenedColor : bm
  };

  let err = false;
  let pic = "./pic/eraser1.svg"
  if(p && c>0){
    if(e > 0){
      err = true;
      pic = e===1 ? "./pic/eraser2.svg" : "./pic/eraser3.svg";
    }else{
      err = false
    }
  }
  const eraserClick=()=>{
    let h=e;
    if(p && c>0){
      h=++h%3;
    }else{
      h = h > 1 ? 1 : h;
      h=++h%2;
    }
    dispatch(setEraserS(h));
  }

  return (
    <Ratio aspectRatio={"1x1"}>
    <div onClick={eraserClick}>
      <div
        className={`${styles.b_e_adiv} ${er}`}
        style={buttonStyle}
      >
        <img src={pic} alt='' className={styles.b_e_img}/>
        {err && <img src='./pic/caret.svg' alt='' className={styles.b_e_img2}/>}
      </div>
    </div>
    </Ratio>
  )
}
